import {validTarget} from './storyRuntime.js';

// The Story panel allows targets up to an hour, while AI drafting currently caps at 15 minutes.
export function initialDraftTargetSeconds(value){
  const target=validTarget(value);
  return target===null?180:Math.min(900,target);
}
export function readableStoryDuration(value){
  const target=validTarget(value);
  if(target===null)return null;
  const minutes=Math.floor(target/60),seconds=target%60;
  const parts=[];
  if(minutes)parts.push(`${minutes} ${minutes===1?'minute':'minutes'}`);
  if(seconds)parts.push(`${seconds} ${seconds===1?'second':'seconds'}`);
  return parts.join(' ');
}
export function projectTargetNote(value){
  const formatted=readableStoryDuration(value);
  return formatted
    ?`Note: Your project has a target duration of ${formatted}, set by the editor in Assembly.`
    :'Note: No project target duration has been set in Assembly yet.';
}
